/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface InscriptionSearch
 */
export interface InscriptionSearch {
    /**
     * 
     * @type {number}
     * @memberof InscriptionSearch
     */
    idapprenant?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InscriptionSearch
     */
    statuts?: Array<string> | null;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionSearch
     */
    codeFormation?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof InscriptionSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof InscriptionSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof InscriptionSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InscriptionSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof InscriptionSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof InscriptionSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the InscriptionSearch interface.
 */
export function instanceOfInscriptionSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionSearchFromJSON(json: any): InscriptionSearch {
    return InscriptionSearchFromJSONTyped(json, false);
}

export function InscriptionSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'statuts': !exists(json, 'statuts') ? undefined : json['statuts'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'codeFormation': !exists(json, 'codeFormation') ? undefined : TextSearchFromJSON(json['codeFormation']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function InscriptionSearchToJSON(value?: InscriptionSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'statuts': value.statuts,
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'codeFormation': TextSearchToJSON(value.codeFormation),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

